import { render, staticRenderFns } from "./CollapsIcon.vue?vue&type=template&id=59e9250c"
import script from "./CollapsIcon.vue?vue&type=script&lang=js"
export * from "./CollapsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports